import React, { useState } from 'react';
import { 
  FaHotel, FaMapMarkerAlt, FaStar, FaCrown, 
  FaHeart, FaChevronRight, FaBed,
  FaSwimmingPool, FaWifi, FaCar,
  FaUtensils, FaSpa, FaConciergeBell
} from 'react-icons/fa';
import { MdLocationOn, MdRestaurant, MdAcUnit } from 'react-icons/md';
import { IoIosFitness, IoMdPeople } from 'react-icons/io';
import '../style.css';

const EliteStaysSection = () => {
  const [activeCity, setActiveCity] = useState('varanasi');
  const [favorites, setFavorites] = useState(new Set());

  const cities = [
    { 
      id: 'varanasi', 
      name: 'Varanasi', 
      icon: <FaHotel />,
      color: '#ff7700'
    },
    { 
      id: 'prayagraj', 
      name: 'Prayagraj', 
      icon: <MdLocationOn />,
      color: '#0052cc'
    },
    { 
      id: 'ayodhya', 
      name: 'Ayodhya', 
      icon: <FaBed />,
      color: '#8e44ad'
    },
    { 
      id: 'gaya', 
      name: 'Gaya/Bodhgaya', 
      icon: <FaCrown />,
      color: '#27ae60'
    }
  ];

  const hotels = {
    varanasi: [
      {
        name: 'The Elegance',
        rating: 4.9,
        price: 12499,
        location: 'Luxury Riverside',
        image: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&h=300&q=80',
        icon: <FaCrown />,
        amenities: [<FaSwimmingPool />, <FaSpa />, <FaUtensils />, <FaWifi />]
      },
      {
        name: 'Rio Benaras',
        rating: 4.8,
        price: 8999,
        location: 'City Center',
        image: 'https://r2imghtlak.mmtcdn.com/r2-mmt-htl-image/htl-imgs/202112081546182213-0ce3bc047ed811ec82340a58a9feac02.jpg?&output-quality=75&downsize=520:350&crop=520:350;4,0&output-format=jpg&downsize=252:160&crop=252:160',
        icon: <FaHotel />,
        amenities: [<MdRestaurant />, <IoIosFitness />, <FaCar />, <FaWifi />]
      },
      {
        name: 'Dev Residency',
        rating: 4.7,
        price: 7499,
        location: 'Near Railway Station',
        image: 'https://images.unsplash.com/photo-1584132967334-10e028bd69f7?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&h=300&q=80',
        icon: <FaConciergeBell />,
        amenities: [<IoMdPeople />, <FaCar />, <FaWifi />, <FaUtensils />]
      },
      {
        name: 'Hotel Vanshi Vat',
        rating: 4.6,
        price: 6499,
        location: 'Traditional Area',
        image: 'https://r2imghtlak.mmtcdn.com/r2-mmt-htl-image/htl-imgs/202412201437134323-1ba5afec-e1a6-4b36-9375-10b3ee5238f7.jpg',
        icon: <FaBed />,
        amenities: [<FaSpa />, <MdAcUnit />, <FaWifi />, <FaUtensils />]
      },
      {
        name: 'Hotel Veda',
        rating: 4.5,
        price: 5499,
        location: 'Peaceful Location',
        image: 'https://images.unsplash.com/photo-1590490360182-c33d57733427?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&h=300&q=80',
        icon: <FaSpa />,
        amenities: [<FaSpa />, <FaBed />, <MdRestaurant />, <FaWifi />]
      },
      {
        name: 'Hotel Ganges Grand',
        rating: 4.8,
        price: 10499,
        location: 'Ghat View',
        image: 'https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&h=300&q=80',
        icon: <FaHotel />,
        amenities: [<FaSwimmingPool />, <FaUtensils />, <FaCar />, <FaConciergeBell />]
      }
    ],
    prayagraj: [
      {
        name: 'The Elegance',
        rating: 4.8,
        price: 9999,
        location: 'Sangam View',
        image: 'https://images.unsplash.com/photo-1611892440504-42a792e24d32?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&h=300&q=80',
        icon: <FaCrown />,
        amenities: [<FaSwimmingPool />, <FaSpa />, <FaUtensils />, <FaWifi />]
      },
      {
        name: 'Rio Benaras',
        rating: 4.7,
        price: 8499,
        location: 'Civil Lines',
        image: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&h=300&q=80',
        icon: <FaHotel />,
        amenities: [<MdRestaurant />, <IoIosFitness />, <FaCar />, <FaWifi />]
      },
      {
        name: 'Dev Residency',
        rating: 4.6,
        price: 6999,
        location: 'Allahabad Junction',
        image: 'https://images.unsplash.com/photo-1584132967334-10e028bd69f7?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&h=300&q=80',
        icon: <FaConciergeBell />,
        amenities: [<IoMdPeople />, <FaCar />, <FaWifi />, <FaUtensils />]
      },
      {
        name: 'Hotel Vanshi Vat',
        rating: 4.5,
        price: 5999,
        location: 'MG Road',
        image: 'https://r2imghtlak.mmtcdn.com/r2-mmt-htl-image/htl-imgs/202412201437134323-1ba5afec-e1a6-4b36-9375-10b3ee5238f7.jpg',
        icon: <FaBed />,
        amenities: [<FaSpa />, <MdAcUnit />, <FaWifi />, <FaUtensils />]
      },
      {
        name: 'Hotel Veda',
        rating: 4.4,
        price: 4999,
        location: 'Quiet Area',
        image: 'https://images.unsplash.com/photo-1590490360182-c33d57733427?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&h=300&q=80',
        icon: <FaSpa />,
        amenities: [<FaSpa />, <FaBed />, <MdRestaurant />, <FaWifi />]
      },
      {
        name: 'Hotel Ganges Grand',
        rating: 4.7,
        price: 8999,
        location: 'Sangam Road',
        image: 'https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&h=300&q=80',
        icon: <FaHotel />,
        amenities: [<FaSwimmingPool />, <FaUtensils />, <FaCar />, <FaConciergeBell />]
      }
    ],
    ayodhya: [
      {
        name: 'The Elegance',
        rating: 4.8,
        price: 10999,
        location: 'Riverside',
        image: 'https://images.unsplash.com/photo-1584132915807-fd1f5fbc078f?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&h=300&q=80',
        icon: <FaCrown />,
        amenities: [<FaSwimmingPool />, <FaSpa />, <FaUtensils />, <FaWifi />]
      },
      {
        name: 'Rio Benaras',
        rating: 4.7,
        price: 7999,
        location: 'City Center',
        image: 'https://r2imghtlak.mmtcdn.com/r2-mmt-htl-image/htl-imgs/202112081546182213-0ce3bc047ed811ec82340a58a9feac02.jpg?&output-quality=75&downsize=520:350&crop=520:350;4,0&output-format=jpg&downsize=252:160&crop=252:160',
        icon: <FaHotel />,
        amenities: [<MdRestaurant />, <IoIosFitness />, <FaCar />, <FaWifi />]
      },
      {
        name: 'Dev Residency',
        rating: 4.6,
        price: 6999,
        location: 'Station Road',
        image: 'https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&h=300&q=80',
        icon: <FaConciergeBell />,
        amenities: [<IoMdPeople />, <FaCar />, <FaWifi />, <FaUtensils />]
      },
      {
        name: 'Hotel Vanshi Vat',
        rating: 4.5,
        price: 5999,
        location: 'Temple Area',
        image: 'https://r2imghtlak.mmtcdn.com/r2-mmt-htl-image/htl-imgs/202412201437134323-1ba5afec-e1a6-4b36-9375-10b3ee5238f7.jpg',
        icon: <FaBed />,
        amenities: [<FaSpa />, <MdAcUnit />, <FaWifi />, <FaUtensils />]
      },
      {
        name: 'Hotel Veda',
        rating: 4.4,
        price: 4999,
        location: 'Peaceful Zone',
        image: 'https://images.unsplash.com/photo-1584132967334-10e028bd69f7?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&h=300&q=80',
        icon: <FaSpa />,
        amenities: [<FaSpa />, <FaBed />, <MdRestaurant />, <FaWifi />]
      },
      {
        name: 'Hotel Ganges Grand',
        rating: 4.7,
        price: 8999,
        location: 'Main Road',
        image: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&h=300&q=80',
        icon: <FaHotel />,
        amenities: [<FaSwimmingPool />, <FaUtensils />, <FaCar />, <FaConciergeBell />]
      }
    ],
    gaya: [
      {
        name: 'The Elegance',
        rating: 4.8,
        price: 9999,
        location: 'Bodhgaya Road',
        image: 'https://images.unsplash.com/photo-1611892440504-42a792e24d32?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&h=300&q=80',
        icon: <FaCrown />,
        amenities: [<FaSwimmingPool />, <FaSpa />, <FaUtensils />, <FaWifi />]
      },
      {
        name: 'Rio Benaras',
        rating: 4.7,
        price: 7999,
        location: 'City Center',
        image: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&h=300&q=80',
        icon: <FaHotel />,
        amenities: [<MdRestaurant />, <IoIosFitness />, <FaCar />, <FaWifi />]
      },
      {
        name: 'Dev Residency',
        rating: 4.6,
        price: 6999,
        location: 'Near Airport',
        image: 'https://images.unsplash.com/photo-1584132967334-10e028bd69f7?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&h=300&q=80',
        icon: <FaConciergeBell />,
        amenities: [<IoMdPeople />, <FaCar />, <FaWifi />, <FaUtensils />]
      },
      {
        name: 'Hotel Vanshi Vat',
        rating: 4.5,
        price: 5999,
        location: 'Temple Road',
        image: 'https://r2imghtlak.mmtcdn.com/r2-mmt-htl-image/htl-imgs/202412201437134323-1ba5afec-e1a6-4b36-9375-10b3ee5238f7.jpg',
        icon: <FaBed />,
        amenities: [<FaSpa />, <MdAcUnit />, <FaWifi />, <FaUtensils />]
      },
      {
        name: 'Hotel Veda',
        rating: 4.4,
        price: 4999,
        location: 'Peaceful Area',
        image: 'https://images.unsplash.com/photo-1590490360182-c33d57733427?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&h=300&q=80',
        icon: <FaSpa />,
        amenities: [<FaSpa />, <FaBed />, <MdRestaurant />, <FaWifi />]
      },
      {
        name: 'Hotel Ganges Grand',
        rating: 4.7,
        price: 8999,
        location: 'Main Road',
        image: 'https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&h=300&q=80',
        icon: <FaHotel />,
        amenities: [<FaSwimmingPool />, <FaUtensils />, <FaCar />, <FaConciergeBell />]
      }
    ]
  };

  const toggleFavorite = (hotelName) => {
    const newFavs = new Set(favorites);
    newFavs.has(hotelName) ? newFavs.delete(hotelName) : newFavs.add(hotelName);
    setFavorites(newFavs);
  };

  const currentHotels = hotels[activeCity] || [];
  const activeCityData = cities.find(city => city.id === activeCity);

  return (
    <section className="fixed-section">
      {/* Background Elements */}
      <div className="fixed-bg-elements">
        <div className="bg-dot dot-1" style={{ background: activeCityData?.color }}></div>
        <div className="bg-dot dot-2" style={{ background: activeCityData?.color }}></div>
        <div className="bg-dot dot-3" style={{ background: activeCityData?.color }}></div>
      </div>

      <div className="fixed-container">
        {/* Header */}
        <div className="fixed-header">
          <div className="fixed-title-group">
            <div className="fixed-tagline">
              <span className="fixed-tagline-text">Elite Stays,</span>
              <span className="fixed-tagline-accent">Elite Travel</span>
            </div>
            <p className="fixed-subtitle">
              Preferred travel partner for India's most prestigious hotels
            </p>
          </div>
          
          <div className="fixed-stats">
            <div className="fixed-stat">
              <div className="fixed-stat-icon">
                <FaHotel />
              </div>
              <div className="fixed-stat-content">
                <span className="fixed-stat-number">50+</span>
                <span className="fixed-stat-label">Hotels</span>
              </div>
            </div>
            <div className="fixed-stat">
              <div className="fixed-stat-icon">
                <FaCrown />
              </div>
              <div className="fixed-stat-content">
                <span className="fixed-stat-number">24</span>
                <span className="fixed-stat-label">Cities</span>
              </div>
            </div>
          </div>
        </div>

        {/* City Tabs */}
        <div className="fixed-city-tabs">
          {cities.map(city => (
            <button
              key={city.id}
              className={`fixed-city-tab ${activeCity === city.id ? 'fixed-tab-active' : ''}`}
              onClick={() => setActiveCity(city.id)}
              style={{
                '--city-color': city.color,
                borderColor: activeCity === city.id ? city.color : 'rgba(0, 82, 204, 0.1)'
              }}
            >
              <div className="fixed-tab-icon" style={{ color: city.color }}>
                {city.icon}
              </div>
              <span className="fixed-tab-name">{city.name}</span>
              {activeCity === city.id && (
                <div className="fixed-tab-indicator" style={{ background: city.color }}></div>
              )}
            </button>
          ))}
        </div>

        {/* Current City Info */}
        <div className="fixed-city-info">
          <div className="city-info-icon" style={{ background: activeCityData?.color }}>
            {activeCityData?.icon}
          </div>
          <div className="city-info-text">
            <h3>Hotels in {activeCityData?.name}</h3>
            <p>Click on different cities to view their premium hotels</p>
          </div>
        </div>

        {/* Hotel Grid - 6 Cards Fixed */}
        <div className="fixed-hotels-grid">
          {currentHotels.map((hotel, index) => (
            <div key={index} className="fixed-hotel-card">
              {/* Hotel Image - Fixed Size */}
              <div className="fixed-image-container">
                <img 
                  src={hotel.image} 
                  alt={hotel.name}
                  className="fixed-hotel-image"
                  loading="lazy"
                />
                <div className="image-overlay-fixed"></div>
                
                {/* Price Tag */}
                <div className="fixed-price-tag">
                  <span className="fixed-price-amount">₹{hotel.price.toLocaleString()}</span>
                  <span className="fixed-price-text">/night</span>
                </div>
                
                {/* Favorite Button */}
                <button
                  className={`fixed-favorite-btn ${favorites.has(hotel.name) ? 'fixed-fav-active' : ''}`}
                  onClick={() => toggleFavorite(hotel.name)}
                >
                  <FaHeart />
                </button>
              </div>

              {/* Hotel Content */}
              <div className="fixed-card-content">
                {/* Hotel Header */}
                <div className="fixed-card-header">
                  <div className="hotel-title-section">
                    <div className="hotel-icon" style={{ color: activeCityData?.color }}>
                      {hotel.icon}
                    </div>
                    <h4 className="fixed-hotel-name">{hotel.name}</h4>
                  </div>
                  <div className="fixed-hotel-rating">
                    <FaStar className="fixed-rating-star" />
                    <span className="fixed-rating-value">{hotel.rating}</span>
                  </div>
                </div>

                {/* Location */}
                <div className="fixed-hotel-location">
                  <FaMapMarkerAlt className="fixed-location-icon" />
                  <span className="fixed-location-text">{hotel.location}, {activeCityData?.name}</span>
                </div>

                {/* Amenities Icons */}
                <div className="fixed-amenities">
                  {hotel.amenities.map((amenity, i) => (
                    <div key={i} className="fixed-amenity-icon" title="Amenity">
                      {amenity}
                    </div>
                  ))}
                </div>

                {/* Book Button */}
                <button className="fixed-book-btn">
                  <span>Book Now</span>
                  <FaChevronRight className="book-icon" />
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="fixed-cta">
          <div className="fixed-cta-icon">
            <FaConciergeBell />
          </div>
          <h3>Ready for a premium experience?</h3>
          <p>Book your elite stay with exclusive partner benefits</p>
          <button className="fixed-cta-btn">
            <FaHotel /> Explore All Hotels
          </button>
        </div>
      </div>
    </section>
  );
};

export default EliteStaysSection;